/* global $ */

import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
  }

  show() {
    $(this.element).modal({
      backdrop: 'static',
      show: true,
      keyboard: false,
    });
  }
}
